<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M8.94112 7.99997L15.9999 0.941174L15.0588 0L7.99994 7.0588L0.9412 4.04867e-05L2.68557e-05 0.941213L7.05877 7.99997L-2.28485e-05 15.0588L0.941149 15.9999L7.99994 8.94115L15.0588 16L16 15.0588L8.94112 7.99997Z"
			fill="#000"
		/>
	</svg>
</template>
